module.exports = require("/Users/jakubchadim/Projects/zskostelec/web/.gatsby/gatsby-browser.tsx");